// Static, server-mirrored content for the magical site
// Cache-bust version — bump when character images are regenerated
const V = "v3";
export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/1ec4323a-aaec-40e1-931b-4e30c59c9b3f/images/1b2526865f1f3aa31ef4dcda154886be0e400b2e40fea5c359b7392e2fd47741.png",
  fairyDoor: "https://static.prod-images.emergentagent.com/jobs/1ec4323a-aaec-40e1-931b-4e30c59c9b3f/images/a7d875a3c779c23a221b0df41362d283db67b6abcce10a5fcbc63742ecac9f33.png",
  author: "/author/sybelle.jpeg",
  prince: `/characters/prince_carmel.png?${V}`,
  pixie1: `/characters/lila.png?${V}`,
  pixie2: `/characters/bram.png?${V}`,
  pixie3: `/characters/sage.png?${V}`,
  pixie4: `/characters/mossy.png?${V}`,
  tiyar: `/characters/queen_tiyar.png?${V}`,
  book1: "https://m.media-amazon.com/images/I/81tdXFpsW-L._AC_UY600_.jpg",
  book2: "https://m.media-amazon.com/images/I/81CEq+z+8NL._AC_UY600_.jpg",
  book3: "https://m.media-amazon.com/images/I/51kIOQ+lGEL._AC_UY600_.jpg",
  book4: "https://m.media-amazon.com/images/I/81glQbZu0+L._AC_UY600_.jpg",
  book5: "https://m.media-amazon.com/images/I/81ksn4Y3muL._AC_UY600_.jpg",
  klay: "https://m.media-amazon.com/images/I/81Cl2pN1ASL._AC_UY600_.jpg",
};

export const CHARACTERS = [
  {
    id: "carmel",
    name: "Prince Carmel",
    title: "Warrior Heir of Miara Mountain",
    blurb: "A young warrior prince with a golden tiara and a heart of unshakable courage. He carries the emerald-tipped scepter of his kingdom and leads his pixie guard through the undiscovered lands.",
    image: IMAGES.prince,
    accent: "Gold",
    skill: "Wields the Scepter of Miara — its emerald gemstone awakens ancient roots and stones in his defence",
    food: "Honeyed acorns and a thimble of warm milkthistle tea",
    appears_in: ["Book One — Born of Kingship", "Book Two — The Gavel of Shadows"],
    fun_fact: "His golden tiara was forged in a single dewdrop by the first pixies of Miara, and rings like a tiny bell when battle calls.",
  },
  {
    id: "lila",
    name: "Lila",
    title: "Blush-Petal Warrior",
    blurb: "Swift as a hummingbird and gentle as rosewater — Lila is the protector of all growing things. Her rose-quartz scepter sings to flowers and calls them to her defence.",
    image: IMAGES.pixie1,
    accent: "Blush",
    skill: "Her rose-quartz scepter summons walls of thorned petals and revives wilted blooms with a single hum",
    food: "Wild strawberries dusted with dawn-frost sugar",
    appears_in: ["Book One — Born of Kingship", "Book Two — The Gavel of Shadows"],
    fun_fact: "Lila braids her own hair every morning using ribbons gifted to her by the sparrows of the Mossleaf Wood.",
  },
  {
    id: "bram",
    name: "Bram",
    title: "The Tinker Warrior",
    blurb: "Mischievous, brilliant and always covered in glow-dust. Bram's amber-gemmed scepter is half weapon, half clockwork marvel — he tinkered it himself from beetle shells and moonlight.",
    image: IMAGES.pixie2,
    accent: "Amber",
    skill: "His amber scepter unfolds into tiny brass machines mid-battle — traps, lanterns, even a flying device for two",
    food: "Honeycomb chunks dunked in fizzy birch-sap soda",
    appears_in: ["Book Two — The Gavel of Shadows"],
    fun_fact: "Bram's pockets are deeper than they look — he once pulled out an entire weather-vane during a thunderstorm.",
  },
  {
    id: "sage",
    name: "Sage",
    title: "Warrior Keeper of Old Songs",
    blurb: "Ageless, wise, and quietly fierce. Sage carries the silver Star-Scepter, whose sapphire holds the memory of every constellation that ever shone over Miara.",
    image: IMAGES.pixie3,
    accent: "Silver",
    skill: "Her Star-Scepter sings a lullaby that puts thunderstorms to sleep and steadies the bravest pixie's hands",
    food: "Moonbell petals steeped in cold spring water",
    appears_in: ["Book One — Born of Kingship", "Book Two — The Gavel of Shadows"],
    fun_fact: "She has been alive for so long that she remembers the day Miara Mountain was no taller than a child's shoulder.",
  },
  {
    id: "mossy",
    name: "Mossy",
    title: "Mushroom-Cap Warrior Scout",
    blurb: "The shyest of the warriors, but the most cunning in the forest. Mossy's emerald scepter grows soft moss under their boots so no enemy hears them coming.",
    image: IMAGES.pixie4,
    accent: "Emerald",
    skill: "Her emerald scepter grows a moss-carpet wherever it touches — quiet footfalls for friends, traps for foes",
    food: "Toasted clover bread and a thimble of wild-mint honey",
    appears_in: ["Book Two — The Gavel of Shadows"],
    fun_fact: "Mossy's mushroom-cap helmet changes colour with their mood — ruby when steady, pale lilac when worried.",
  },
  {
    id: "tiyar",
    name: "Queen Tiyar",
    title: "Dark Sovereign of the Orm Elves",
    blurb: "Ageless, cunning and bitterly powerful. Queen Tiyar is the shadow over Miara Mountain — a sorceress-queen whose ambition turned her court to obsidian and her heart to ice. Her menacing presence is the reason Prince Carmel must learn to be brave.",
    image: IMAGES.tiyar,
    accent: "Onyx",
    skill: "The blood-ruby Scepter of Tiyar binds shadows to her will and can silence even the loudest battlefield",
    food: "Bitter nightshade tea and pomegranate seeds served on black obsidian",
    appears_in: ["Book One — Born of Kingship", "Book Two — The Gavel of Shadows"],
    fun_fact: "Her crown is said to be carved from a single piece of fallen sky — and the stars refuse to shine wherever she walks.",
  },
];

export const RETAILERS = [
  { name: "Amazon", url: "https://www.amazon.com/stores/Sybelle-Cheesman/author/B0CSBZ2BXR" },
];

export const AMAZON_AUTHOR_URL = "https://www.amazon.com/stores/Sybelle-Cheesman/author/B0CSBZ2BXR";

export const BOOK_FORMATS = {
  book_1: [
    { label: "Paperback", price: 15.99, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-Kingship/dp/0692608842" },
    { label: "Kindle", price: 6.00, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-Kingship-ebook/dp/B07SZHL9PP" },
  ],
  book_2: [
    { label: "Paperback", price: 15.99, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-Continence/dp/0692644164" },
    { label: "Kindle", price: 10.99, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-2nd-ebook/dp/B01BT36PCI" },
  ],
  book_3: [
    { label: "Paperback", price: 15.99, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-3rd/dp/1543083420" },
    { label: "Kindle", price: 3.99, url: "https://www.amazon.com/Carmel-Prince-Mountain-Revised-Version-ebook/dp/B06WVD4S1L" },
  ],
  book_4: [
    { label: "Paperback", price: 15.99, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-Mysterious/dp/B0B1ZMQY8Z" },
    { label: "Kindle", price: 7.99, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-Mysterious-ebook/dp/B0B21FV8Q9" },
  ],
  book_5: [
    { label: "Paperback", price: 15.99, url: "https://www.amazon.com/Carmel-Prince-Miara-mountain-Shadows/dp/B0DKD5KT3W" },
    { label: "Hardcover", price: 29.99, url: "https://www.amazon.com/Carmel-Prince-Miara-mountain-Shadows/dp/B0DL4C2JHL" },
    { label: "Kindle", price: 4.99, url: "https://www.amazon.com/Carmel-Prince-Miara-Mountain-Shadows-ebook/dp/B0DKD3B9M6" },
  ],
  klay: [
    { label: "Paperback", price: 14.99, url: "https://www.amazon.com/Klay-Realm-Gods-Watchers-Grators/dp/B0B2TTDB71" },
    { label: "Kindle", price: 7.99, url: "https://www.amazon.com/Klay-Realm-Gods-Watchers-Grators-ebook/dp/B0B2ZGWXNF" },
  ],
};

export const BOOK_COVERS = {
  book_1: IMAGES.book1,
  book_2: IMAGES.book2,
  book_3: IMAGES.book3,
  book_4: IMAGES.book4,
  book_5: IMAGES.book5,
  klay: IMAGES.klay,
};
